'use client';
import { useEffect } from 'react';

 import Header from'@/components/common/Header';
 import Footer from'@/components/common/Footer';
 import HeroSection from'./components/HeroSection';
 import FeaturedSaintsSection from'./components/FeaturedSaintsSection';
 import PatronageSection from'./components/PatronageSection';
 import HowItWorksSection from'./components/HowItWorksSection';
 import TestimonialsSection from'./components/TestimonialsSection';
import NewsletterSection from './components/NewsletterSection';

export default function Homepage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals?.length) return
    
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals?.forEach(el => observer?.observe(el))
  }, [])

  return (
    <>
      <Header />
      <main className="min-h-screen">
        <HeroSection />
        <FeaturedSaintsSection />
        <PatronageSection />
        <HowItWorksSection />
        <TestimonialsSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  )
}